import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserDetailService } from './user-detail.service';

export const organisationAdminGuard: CanActivateFn = (route, state) => {
  const userDetailService = inject(UserDetailService);
  const router = inject(Router);
  if (userDetailService.getUserData().isOrganisationAdmin) {
    return true;
  } else {
    router.navigateByUrl('/home');
    return false;
  }
};
